// src/components/InstitutionalSchedulePage.jsx
import React, { useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import LiveScheduleView from './LiveScheduleView'; // Correct path
import { setLastInstitutionUrlEndpoint } from '../utils/lastInstitutionUrlEndpoint';

const InstitutionalSchedulePage = ({ user, teachers, groups, subjects, rooms, isAssetsLoading = false, onAddGroup }) => {
    const { institutionUrlEndpoint, scheduleShareSlug } = useParams();

    console.log('[InstitutionalSchedulePage] Rendering for endpoint:', institutionUrlEndpoint);

    const filters = useMemo(() => {
        return {};
    }, []);

    const include = useMemo(() => (
        'subject,teacher,group,room'
    ), []);

    useEffect(() => {
        if (institutionUrlEndpoint && !scheduleShareSlug) {
            setLastInstitutionUrlEndpoint(institutionUrlEndpoint);
        }
    }, [institutionUrlEndpoint, scheduleShareSlug]);

    return (
        <div>
            <LiveScheduleView
                user={user}
                teachers={teachers}
                groups={groups}
                subjects={subjects}
                rooms={rooms}
                isAssetsLoading={isAssetsLoading}
                filters={filters}
                include={include}
                isPublicView={true}
                isScheduleShare={!!scheduleShareSlug}
                onAddGroup={onAddGroup}
            />
        </div>
    );
};

export { InstitutionalSchedulePage };
